import {coachingApi} from 'sources/api';
import {Moment} from 'moment';
import {UserId} from 'records/User';
import {Int, Minutes} from '@store/@types/util';
import {DayOfWeek} from '@store/@types/util/time/DayOfWeek';
import {DateFormat} from 'utils/datetime/DateFormat';

interface FindTimesRequest {
  user_ids: UserId[];
  duration: Minutes;
  day: DayOfWeek | string;
  time: string;
  weeks: Int;
  start: string | undefined;
}

export class CalendarNylasSource {
  static fetchFindTimes(
    userIds: string[],
    meetingMinutes: number,
    searchWeeks: number,
    day: string,
    time: string,
    startDate: Moment | undefined
  ): Promise<string[]> {
    const params: FindTimesRequest = {
      user_ids: userIds,
      duration: meetingMinutes,
      weeks: searchWeeks,
      day: day,
      time: time,
      start: startDate ? startDate.format(DateFormat.YYYY_MM_DD) : startDate,
    };

    return coachingApi.getJson<string[]>(`/plans/find_time`, {params});
  }
}
